import Vue from "vue";
import Vuex from "vuex";
import Service from "@/service/api";
import router from "@/router/index";
import store from "@/store/store";

const ServerModule = {
    namespaced: true,
    state: {
        item : [],
    },

    mutations: {
        item(state, obj) {
            state.item = obj;
        }
    },

    actions: {
        config({commit}, data) {
            Service.agency('exp', data, {})
                .then((response) => {
                    store.commit("agency/item", response.data.data)
                }).catch((err) => {
            });
        }
    },

    getters: {
        item(state, obj) {
            return state.item;
        },
    },
};

export default ServerModule;
